module.exports = __webpack_public_path__ + "img/analysis_01_m.463031b8.png";